"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bn_js_1 = __importDefault(require("bn.js"));
const constants_1 = require("./constants");
function convertUnit(value, from = constants_1.Units.Wei, to = constants_1.Units.Ether) {
    let result = null;
    if (typeof value === 'number') {
        value = new bn_js_1.default(value, 10);
    }
    if (from === to) {
        result = value;
    }
    else {
        try {
            const fromPow = constants_1.unitsPow[from];
            const toPow = constants_1.unitsPow[to];
            if (fromPow.gt(toPow)) {
                result = value.mul(fromPow.div(toPow));
            }
            else {
                result = value.div(toPow.div(fromPow));
            }
        }
        catch (err) {
            result = null;
        }
    }
    return result;
}
exports.convertUnit = convertUnit;
function ethToWei(value) {
    value = Math.floor(value * Math.pow(10, 6));
    return convertUnit(value, constants_1.Units.Szabo, constants_1.Units.Wei);
}
exports.ethToWei = ethToWei;
function weiToEth(value) {
    value = convertUnit(value, constants_1.Units.Wei, constants_1.Units.Szabo);
    return value.toNumber() / Math.pow(10, 6);
}
exports.weiToEth = weiToEth;
//# sourceMappingURL=utils.js.map